import React, { useEffect, useState } from 'react';
import { format, parseISO } from 'date-fns';
import './session-card.css';
import PersonIcon from '@mui/icons-material/Person';
import DeleteIcon from '@mui/icons-material/Delete';

import CreateIcon from '@mui/icons-material/Create';

import { accessToken } from 'utils';
import axios from 'axios';
import { Webex_Base_Url } from 'utils';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';

import { useNavigate } from 'react-router-dom';
const SessionCard = ({
  meeting,
  webex,
  selectedDate,
  setOnGoingMeeting,
  setHostKey,
  setApiMeetingId,
  getMeeting,
  setIsEditing,
  setEditData,
  setOpenAddSession,
  firebaseMeeting,
  setMeetingJoinClicked,
  meetingJoinClicked,
  isTeacher,
  notify,
}) => {
  const [sdkMeeting, setSdkMeeting] = useState();
  const [isStarting, setIsStarting] = useState(false);

  const formatTo12HourTime = (isoString) => {
    const date = new Date(isoString);
    let hours = date.getHours(); // local hours
    const minutes = date.getMinutes(); // local minutes
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${hours}:${formattedMinutes}${ampm}`;
  };

  // const { setWebex, setMeeting } = useWbex();

  const time = meeting?.start ? formatTo12HourTime(meeting?.start) : '';

  const isCurrentTimeInRange = (startTime, endTime) => {
    const now = Date.now();
    const start = new Date(startTime).getTime();
    const end = new Date(endTime).getTime();
    if (now >= start && now < end) {
      return { isInRange: true, isEnded: false };
    } else if (now >= end) {
      return { isInRange: false, isEnded: true };
    } else {
      return { isInRange: false, isEnded: false };
    }
  };

  let token = accessToken();
  const navigate = useNavigate();

  const meetingStatus = meeting?.start
    ? isCurrentTimeInRange(meeting?.start, meeting?.end)
    : '';

  const getLocalStreams = async () => {
    try {
      const microphoneStream =
        await webex.meetings.mediaHelpers.createMicrophoneStream({});
      const cameraStream = await webex.meetings.mediaHelpers.createCameraStream(
        {}
      );

      return {
        microphone: microphoneStream,
        camera: cameraStream,
      };
    } catch (error) {
      console.error('❌ Error getting local streams:', error);
    }
  };

  const joinMeetingWithMedia = async (meeting) => {
    try {
      const { microphone, camera } = await getLocalStreams();

      const options = {
        joinOptions: {
          pin: meeting?.hostKey,
          moderator: false,
          enableMultistream: true,
        },
        mediaOptions: {
          localStreams: {
            microphone: microphone,
            camera: camera,
          },
          audioEnabled: true,
          videoEnabled: true,
          shareVideoEnabled: true,
          shareAudioEnabled: false,
          allowMediaInLobby: true,
        },
      };

      if (meeting) {
        // await meeting.join(options.joinOptions)?.then(() => {
        //   setOnGoingMeeting(meeting);
        //   handleMeetingScreen();
        // });
      }
      console.log('✅ Joined Meeting with Media');
    } catch (error) {
      console.error('❌ Error joining meeting:', error);
    }
  };

  const handleSdkJoinMeeting = async (startLink) => {
    try {
      await webex.meetings.register()?.then((res) => {
        console.log(res, 'register');
      });
      let id;

      if (!sdkMeeting) {
        await webex.meetings.create(startLink, 'SIP_URI')?.then((res) => {
          id = res?.id;
        });
      }
      let meetings = !sdkMeeting
        ? await webex.meetings.getAllMeetings()[id]
        : sdkMeeting;
      if (meetings) {
        // setWebex(webex);
        // setMeeting(meetings);
        setIsStarting(false);
        setOnGoingMeeting(meetings);
        setHostKey(meeting?.hostKey);
        setApiMeetingId();
        setMeetingJoinClicked(false);

        // handleMeetingScreen();

        navigate('/session', {
          state: {
            hostKey: meeting?.hostKey,

            apiMeetingId: meeting?.id,
            ongoingclassName: meeting?.title,
          },
        });

        console.log('success res1', meetings);
        // joinMeetingWithMedia(meetings[Object?.keys(meetings)[0]]);
        // meetings[Object?.keys(meetings)[0]]?.join()?.then((res) => {
        //   debugger;
        // });
      }
    } catch (error) {
      console.log('Error checker while register', error);
    }
  };

  function checkDateStatus(dateString) {
    const inputDate = new Date(dateString);
    const today = new Date();

    // Reset time to ignore time differences
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (inputDate < today) return 'past';
    if (inputDate > today) return 'future';
    return 'today';
  }

  const selectedDateStatus = selectedDate ? checkDateStatus(selectedDate) : '';

  const checkIsMeetingEndedToday = () => {
    if (!firebaseMeeting?.lastStartedOn?._seconds) {
      return '';
    }
    let today = new Date();
    let date = new Date(firebaseMeeting?.lastStartedOn?._seconds * 1000);
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    return isToday && firebaseMeeting?.status == 'ended';
  };

  // const isMeetingEndedToday = checkIsMeetingEndedToday();

  const joinMeeting = async () => {
    if (!webex) {
      alert('Webex not initialized!');
      return;
    }
    setMeetingJoinClicked(true);
    let token = accessToken();
    setIsStarting(true);

    handleSdkJoinMeeting(meeting?.sipAddress);
    // });
  };

  const deleteClassByMeetingFirebase = async (webExMeetingId) => {
    try {
      const batchClassesRef = db.collection('BatchClasses');
      const querySnapshot = await batchClassesRef
        .where('webExMeetingId', '==', webExMeetingId)
        .limit(1)
        .get();

      if (querySnapshot.empty) {
        console.log('No matching document found to delete.');
        return;
      }

      const doc = querySnapshot.docs[0];
      await doc.ref.delete();

      console.log(
        `Deleted document with ID: ${doc.id} and webExMeetingId: ${webExMeetingId}`
      );
    } catch (error) {
      console.error('Error deleting document: ', error);
    }
  };

  const deleteClassByMeetingWebex = async (webExMeetingId) => {
    try {
      await axios.delete(
        `${Webex_Base_Url}/v1/meetings/${webExMeetingId}`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
    } catch (error) {}
  };

  const deleteMeet = async (webExMeetingId) => {
    document.querySelector('#loading-indicator').style.display = 'flex';

    deleteClassByMeetingWebex(webExMeetingId)
      ?.then((res) => {
        deleteClassByMeetingFirebase(webExMeetingId)
          ?.then((res) => {
            getMeeting();

            notify('Class deleted successfully', false);
            document.querySelector('#loading-indicator').style.display = 'none';
          })
          ?.catch((err) => {
            notify('Something went wrong', true);

            document.querySelector('#loading-indicator').style.display = 'none';
          });
      })
      ?.catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';

        notify(err?.response?.data?.message, true);
      });
  };
  const syncWebex = async (webex) => {
    try {
      await webex.meetings.syncMeetings();
    } catch (error) {}
  };
  const getOngoingMeeting = async () => {
    await syncWebex();
    let meetingNow;
    let ongoingMeetingList = await webex?.meetings?.getAllMeetings();

    if (ongoingMeetingList && Object?.keys(ongoingMeetingList)?.length > 0) {
      Object.values(ongoingMeetingList)?.map((meet) => {
        if (meet?.meetingNumber == meeting?.meetingNumber) {
          setSdkMeeting(meet);
          // Object?.values(meet?.members?.membersCollection?.members)?.map(
          //   (member) => {
          //     if (member?.isSelf && member?.isInMeeting) {
          //       meetingNow = meet;
          //     }
          //   }
          // );
        }
      });
    }
    console.log(ongoingMeetingList, meetingNow, 'leftttttt');

    // if (meetingNow) {
    //   await webex.meetings.register()?.then((res) => {});
    //   try {
    //     await meetingNow?.leave();
    //   } catch (error) {}
    // }
  };

  useEffect(() => {
    if (webex) getOngoingMeeting();
  }, [webex]);

  return (
    <>
      <div className='session-card-main-container'>
        {!isTeacher && (
          <div className='session-card-action-container'>
            <CreateIcon
              onClick={() => {
                setIsEditing(true);
                setOpenAddSession(true);
                setEditData(firebaseMeeting);
              }}
              style={{ fontSize: '18px' }}
            />
            <DeleteIcon
              onClick={() => deleteMeet(meeting?.id)}
              style={{ fontSize: '18px' }}
            />
          </div>
        )}
        <div className='session-card-content-container'>
          <p className='session-card-title'>
            {meeting?.title?.length > 10
              ? `${meeting?.title?.slice(0, 10)}...`
              : meeting?.title}
          </p>
          <p className='session-card-time'>{time}</p>
        </div>
        <div className='session-card-content-container'>
          <div className='session-card-host-container'>
            <PersonIcon
              style={{
                color: '#e3f988',
                fontSize: '20px',
              }}
            />
            <p className='session-card-content-host'>
              {firebaseMeeting?.invitees?.displayName
                ? firebaseMeeting?.invitees?.displayName
                : meeting?.hostDisplayName?.length > 20
                ? `${meeting?.hostDisplayName?.slice(0, 20)}...`
                : meeting?.hostDisplayName}
            </p>
          </div>
          {/* {meetingStatus?.isEnded ? (
          ''
        ) : ( */}
          {selectedDateStatus == 'past' ? (
            <button
              disabled
              className='session-card-start-button'
              onClick={joinMeeting}
            >
              Expired
            </button>
          ) : selectedDateStatus == 'future' ? (
            <></>
          ) : (
            <button
              disabled={meetingJoinClicked || !webex}
              // disabled={meetingStatus?.isInRange}
              className='session-card-start-button'
              onClick={joinMeeting}
            >
              {isStarting ? 'Starting...' : 'Start'}
            </button>
          )}
          {/* )} */}
        </div>
      </div>
    </>
  );
};

export default SessionCard;
